import { css } from "emotion";
import Button from "../../../components/global/Button";
import { H2, H3, Note } from "../../../components/text/TextComponents";
import { max } from "../../../utils/CssUtils";
import ColorServices from "../../../services/ColorServices";
import { SignUpButton } from "../../../components/global";

const getPinholes = asset =>
  `../../../assets/FeaturesAndPricing/${asset}_pinholes.png`;

const priceBlockWrapper = css({
  height: 174,
  position: "relative",
  paddingLeft: 24,
  paddingRight: 24,
  marginBottom: 0,
  button: {
    fontSize: 16
  }
});

const pricingDescWrapper = css({
  maxWidth: 200,
  textAlign: "left",
  margin: "0 auto",
  letterSpacing: -0.28
});

const ticketFeeBrackets = css({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  height: 114
});

const perTicket = css({
  fontSize: 12,
  fontWeight: 600,
  color: ColorServices.getColor("textGrey")
});

const featureListWrapper = css({
  textAlign: "left",
  padding: "24px",
  backgroundColor: ColorServices.getColor("greyBackground"),
  height: 198,
  ul: {
    paddingLeft: 18,
    margin: 0,
    listStyleImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='12' viewBox='-1 -1 2 2'><circle r='1' fill='%23323232'/></svg>")`
  },
  li: {
    padding: "0 16px 8px 16px",
    lineHeight: "22px",
    letterSpacing: "-0.33px",
    [max(768)]: {
      fontSize: 14
    }
  }
});

const Plan = ({
  firstPlan,
  heading,
  priceBlock,
  featureList,
  colour,
  locale
}) => {
  const block = css({
    marginBottom: 24,
    borderRadius: 4,
    width: 330,
    background: "#ffffff",
    boxShadow: "0 1px 10px 0 rgba(9, 30, 66, 0.13)",
    float: "left",
    marginLeft: firstPlan ? 0 : 25,
    "@media(max-width: 1024px)": {
      marginLeft: 0,
      width: "100%"
    }
  });

  const headingBlock = css({
    height: 68,
    textAlign: "center",
    backgroundColor: ColorServices.getColor(colour),
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    paddingTop: 23,
    backgroundImage: `url(${getPinholes(colour)})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "2px 2px",
    backgroundSize: "contain",
    h3: {
      color: colour === "turquoise" ? "#323232" : "#FFFFFF"
    },
    "@media(max-width: 1024px)": {
      height: 50,
      paddingTop: 16,
      backgroundSize: "auto 49px"
    }
  });

  const buttonProps = {
    size: "wide",
    style: priceBlock.buttonStyle,
    color: "secondary",
    link: priceBlock.buttonLink,
    ariaLabel: `${heading} ${priceBlock.buttonText} link`
  };

  return (
    <div className={block}>
      <div className={headingBlock}>
        <H3>{heading}</H3>
      </div>
      <div className={priceBlockWrapper}>
        <div className={ticketFeeBrackets}>
          <H2>
            {priceBlock.priceString}{" "}
            {priceBlock.perTicketNote && (
              <span className={perTicket}>per ticket</span>
            )}
          </H2>
          <div className={pricingDescWrapper}>
            {priceBlock.pricingDesc ? (
              <Note>{priceBlock.pricingDesc}</Note>
            ) : null}
          </div>
        </div>
        {priceBlock.isSignUpButton ? (
          <SignUpButton {...buttonProps}>{priceBlock.buttonText}</SignUpButton>
        ) : (
          <Button {...buttonProps}>{priceBlock.buttonText}</Button>
        )}
      </div>
      <div className={featureListWrapper} role="list">
        <ul>
          {featureList.features.map(feature => (
            <li>{feature}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Plan;
